/**
 * Distinct, color-blind-friendly-ish Mantine color references for chart
 * series. `@mantine/charts` resolves the `"name.shade"` form to a theme color,
 * so these work directly as `series[].color`, legend swatches, and reference
 * lines.
 */
export const SERIES_COLORS = [
  "indigo.6",
  "teal.6",
  "grape.6",
  "orange.6",
  "cyan.7",
  "pink.6",
  "lime.7",
  "blue.6",
  "red.6",
  "violet.6",
  "yellow.7",
  "green.7",
] as const;

export function colorForIndex(i: number): string {
  return SERIES_COLORS[i % SERIES_COLORS.length] ?? "indigo.6";
}
